import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicDeposit({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.81 1.16a.85.85 0 00-.62 1.59 5.65 5.65 0 01.1 10.47.85.85 0 00.65 1.56A7.35 7.35 0 009.8 1.16zM7.25 5.2l2.5 2.25A.8.8 0 0110 8c0 .2-.1.4-.25.55l-2.5 2.25c-.15.15-.3.2-.5.2a.77.77 0 01-.75-.75c0-.2.1-.4.25-.55l1.05-.95H2.75A.77.77 0 012 8c0-.4.35-.75.75-.75H7.3L6.25 6.3A.8.8 0 016 5.75c0-.4.35-.75.75-.75.2 0 .35.1.5.2z"
      />
    </svg>
  );
}

SvgBasicDeposit.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicDeposit.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicDeposit svgRef={ref} {...props} />);
export default ForwardRef;
